module.exports = __webpack_public_path__ + "static/media/Group 1072 (1).6aad1a55.svg";